// extracted by mini-css-extract-plugin
export default {"container":"SignatureList_container__bFEnQ","signatureImage":"SignatureList_signatureImage__Nyrfm","actions":"SignatureList_actions__X8h5B"};